export default __webpack_public_path__ + "static/media/taladrod.28bd8ebd.png";